import React, { useEffect } from 'react';
import {
    Grid, Box, Button, CardHeader,
    Card, Typography, Paper, CardContent, Link
} from '@mui/material';
import { useRedirect } from 'react-admin';

import SketchPluginIcon from '@mui/icons-material/Extension';

import ProjectHistoryView from './management/ProjectResourceHistoryView.js'
import ProjectHistoryTimeView from './management/ProjectHistoryTimeView.js'
import ProjectReportView from './management/ProjectReportView.js'
import { getSelectedProject } from './common/common.js'

export default () => {
    const redirect = useRedirect()

    useEffect(() => {
        const redirect_url = localStorage.getItem("redirect_url")
        if (redirect_url) {
            localStorage.removeItem("redirect_url")
            let url = new URL(redirect_url)
            let path = redirect_url.replace(url.origin, '')
            path = path.replace('/#', '')
            //console.log('redirect_url', path)
            redirect(path)
            return (
                <div />
            )
        }
    }, [])

    return (
        <Box m={2}>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <ProjectHistoryTimeView project_id={getSelectedProject()} />
                </Grid>
                <Grid item xs={6}>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Error Report
                            </Typography>
                            <ProjectReportView project_id={getSelectedProject()} />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Sketch Plugin
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                Sketch Plugin(0.2.1) help you to upload sketch file
                                Download and exeute sketch plugin
                            </Typography>
                            <Link href="https://console.deavil.com/devil_plugin.sketchplugin.zip">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SketchPluginIcon />}
                                >
                                    Download Sketch Plugin
                                </Button>
                            </Link>
                        </CardContent>
                    </Card>
                </Grid>

                
                
                <Grid item xs={4}>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Document
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                Quick start guide and reference
                                https://document.devil-app-builder.com
                            </Typography>
                            <Box mt={1}>
                                <Button
                                    variant="outlined"
                                    target="_blank"
                                    component="a"
                                    href="https://document.devil-app-builder.com">
                                    Go to Document
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={4}>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Comunity
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                Online Q&A and discussion.
                                Discuss with other users and DAB Operator.
                            </Typography>
                            <Box mt={1}>
                                <Button
                                    variant="outlined"
                                    target="_blank"
                                    component="a"
                                    href="https://discord.gg/Z3ZdYY29">
                                    Go to Discord
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={4}>
                    <Card variant="outlined">
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                DAB App
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                DAB App is a mobile app for Viewer and Tester
                            </Typography>
                            <Box mt={1}>
                                <Button
                                    variant="outlined"
                                    target="_blank"
                                    component="a"
                                    href="https://dab.page.link/download">
                                    Download
                                </Button>
                            </Box>
                            <Box mt={1}>
                                <img style={{ width: 150 }} src="/qrcode.webp" />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                {/* <Grid item xs={6}>
                <Paper className={classes.paper}>xs=6</Paper>
            </Grid>
            <Grid item xs={6}>
                <Paper className={classes.paper}>xs=6</Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper className={classes.paper}>xs=3</Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper className={classes.paper}>xs=3</Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper className={classes.paper}>xs=3</Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper className={classes.paper}>xs=3</Paper>
            </Grid> */}
            </Grid>
        </Box>
    )
};
